export default {
  header: 'ניהול תיקים',
  clients: 'מספרי תיק',
  number: 'מספר תיק',
  addNewClient: 'הוספת תיק',
  accordType: 'סוג תיק',
  uid: 'מספר מזהה',
  company: 'חברה מנהלת',
  commission: 'עמלת סוכן %',
  branch: 'מוצר',
  addClient: 'הוספת תיק חדש',
  clientName: 'שם לקוח',
  comments: 'הערות',
  deleteClient: 'מחק תיק',
  updataSuccess: 'תיק עודכן בהצלחה',
  errorUpdating: 'שגיאה בעדכון תיק',
  deleteSuccess: 'תיק הועבר לארכיון בהצלחה',
  errorDeleting: 'שגיאה בהעברת תיק לארכיון',
  verifyDeletion: 'האם אתה בטוח שברצונך למחוק את התיק?',
  deletionReason: 'סיבת מחיקה',
};
